import { Link } from '@mui/material'
import TranspotsLoading from 'components/transpots-loading/transpots-loading.component'
import { useGetPreSignedUrlMutation } from 'store/invoices/invoices.api'
import { InvoiceDocument as InvoiceDocumentType } from 'store/invoices/invoices.types'

interface IProps {
  document: InvoiceDocumentType
}

const InvoiceDocument = ({ document }: IProps) => {
  const [getPresignedUrl, { isLoading, isError }] = useGetPreSignedUrlMutation()

  const handleOpenDocument = async (s3URL: string) => {
    const { data } = await getPresignedUrl({ s3URL, openInline: true })

    if (!isError && data) {
      window.open(data?.preSignedURL, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <>
      <Link
        underline="none"
        sx={{ cursor: 'pointer', fontWeight: 700, fontSize: 15 }}
        onClick={() => handleOpenDocument(document.s3Path)}
      >
        {document.documentName}
      </Link>
      {isLoading && <TranspotsLoading loadingText="Fetching document..." />}
    </>
  )
}

export default InvoiceDocument
